/**
 * FAQ カテゴリタブ切り替え
 */
let faq = () => {
  const navItems = document.querySelectorAll('.p-faq__nav-item');
  if (!navItems.length) return;

  navItems.forEach(btn => {
    btn.addEventListener('click', () => {
      const tab = btn.dataset.tab;

      navItems.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      document.querySelectorAll('.p-faq__panel').forEach(panel => {
        panel.classList.toggle('is-active', panel.dataset.panel === tab);
      });
    });
  });
};

let init = () => {
  faq();
};

export default { init, faq };
